import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { postTaylorFormImport, isEncryptedTaylorPayload } from "../../utils/adminTaylorImport";

export default function AdminTaylorImportModal({
  open,
  onClose,
  title,
  importPath,
  isAdminUser,
  onImported,
}) {
  const fileInputRef = useRef(null);
  const [importing, setImporting] = useState(false);

  if (!open) return null;

  const handleClose = () => {
    onClose();
  };

  const handleEncryptedFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!isAdminUser) {
      toast.error("Only admin can upload encrypted file.");
      return;
    }
    setImporting(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith("/") ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const fileText = await file.text();
      if (!isEncryptedTaylorPayload(fileText)) {
        toast.error("Please upload a valid .taylor encrypted file.");
        return;
      }
      const { ok, data } = await postTaylorFormImport(baseUrl, token, importPath, file);
      if (ok && data?.success) {
        const insertedRow = data?.data && typeof data.data === "object" ? data.data : null;
        if (onImported) onImported({ insertedRow, raw: data });
        toast.success(data?.message || "Import success");
        handleClose();
      } else {
        toast.error(data?.message || "Import failed");
      }
    } catch (error) {
      toast.error(error?.message || "Import failed");
    } finally {
      setImporting(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  return (
    <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.3)" }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div className="modal-content" style={{ maxWidth: "900px", margin: "0 auto" }}>
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                if (!importing) handleClose();
              }}
            ></button>
          </div>
          <div className="modal-body">
            <input
              ref={fileInputRef}
              type="file"
              accept=".taylor,application/octet-stream"
              className="form-control"
              disabled={importing}
              onChange={handleEncryptedFile}
            />
            {importing && (
              <p style={{ marginTop: 12, marginBottom: 0, color: "#8b1634", fontWeight: 600 }}>
                Importing and decrypting file...
              </p>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" disabled={importing} onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function adminIsPrimaryAdmin() {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    return String(u?.role || "").toLowerCase() === "admin";
  } catch {
    return false;
  }
}
